import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthUser } from 'api/AuthApi';
import { PaymentPlan } from 'api/PaymentApi';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

interface EcommercePayload {
  id: string;
  created: number;
  currency: string;
  total: number;
  subtotal: number;
  plan: PaymentPlan;
  couponName: string | null;
  user: AuthUser | null;
}

const slice = createSlice({
  name: 'ecommerce',
  initialState: {},
  reducers: {
    purchaseEvent(state, action: PayloadAction<EcommercePayload>) {
      const order = action.payload;

      window.dataLayer.push({ ecommerce: null });
      if (order) {
        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: order.id,
            // Sum of (price * quantity) for all items.
            value: order.total / 100,
            currency: 'USD',
            coupon: order.couponName || '',
            items: [
              {
                item_id: order.plan.name,
                item_name: order.plan.name,
                coupon: order.couponName || '',
                discount: (order.subtotal - order.total) / 100,
                index: 0,
                price: order.plan.prices[0].amount / 100,
                quantity: 1
              }
            ]
          }
        });
      }
    }
  }
});

export const { purchaseEvent } = slice.actions;
export default slice.reducer;
